// src/modules/operaciones/inventarios/components/Banner.js
//
// Banner de mensajes y barra de progreso del cálculo de precios.
import React from "react"; // Importa React para usar JSX
import { BANNER, BTN_PRIMARY } from "../utils/constantes"; // Clases de banner y botón primario

// Banner de mensajes (éxito, advertencia, error, info)
export const Banner = ({ mensaje, onReintentar, onCerrar }) => (
  // Contenedor accesible: role alert para errores/advertencias, status para el resto
  <div
    role={mensaje.type === "error" || mensaje.type === "warning" ? "alert" : "status"}
    className={`mb-6 p-4 rounded-2xl text-xs font-bold flex justify-between items-center backdrop-blur-md inv-slide-up ${
      BANNER[mensaje.type] || BANNER.error
    }`}
  >
    {/* Texto del mensaje */}
    <span>{mensaje.text}</span>
    {/* Errores muestran Reintentar; el resto muestra cerrar */}
    {mensaje.type === "error" ? (
      <button onClick={onReintentar} className={`ml-4 ${BTN_PRIMARY}`}>
        Reintentar
      </button>
    ) : (
      <button onClick={onCerrar} aria-label="Cerrar mensaje" className="ml-4 cursor-pointer">
        ✕
      </button>
    )}
  </div>
);

// Barra de progreso del cálculo de precios
export const BarraProgreso = ({ progreso }) => (
  // Contenedor azul con animación de entrada
  <div className="mb-4 p-4 rounded-2xl bg-blue-500/10 border border-blue-500/20 backdrop-blur-md inv-fade-in">
    {/* Fila con texto de estado y contador */}
    <div className="flex justify-between items-center mb-2 text-xs font-bold text-blue-900">
      <span>⏳ {progreso.texto}</span>
      <span>
        {progreso.actual} / {progreso.total}
      </span>
    </div>
    {/* Pista de la barra */}
    <div className="w-full h-2 bg-blue-500/20 rounded-full overflow-hidden">
      {/* Relleno: ancho = porcentaje completado */}
      <div
        className="h-full bg-blue-500 transition-all duration-500"
        style={{ width: `${progreso.total > 0 ? Math.round((progreso.actual / progreso.total) * 100) : 0}%` }}
      />
    </div>
  </div>
);